import {fetchAllListPages} from '../../../service/listPagination'
import { roleCheck } from '../../../service/role';
import { canAssignUserRole, hasAction } from '../../../service/permissions';
import React, { useState, useEffect } from "react";
import { useSubheader } from "../../../../_metronic/layout";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar
} from "../../../../_metronic/_partials/controls";
import { useHistory } from "react-router-dom";
import { baseURL } from "../../../service/API.js";
import axios from "axios";
import { TextField } from '@material-ui/core'
import { Link } from "react-router-dom";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { useSelector } from "react-redux";
import { useIntl } from "react-intl";
import Swal from "sweetalert2";
import { apiMessage } from "../../../service/apiError";
import "../component.css";
import Autocomplete from "@material-ui/lab/Autocomplete";

export const CreateUser = (props) => {
  const intl = useIntl();
  const suhbeader = useSubheader();
  suhbeader.setTitle(
    intl.formatMessage({
      id: "109036",
      defaultMessage: "Create User management",
    })
  );
  const history = useHistory();
  const [_id, _setId] = useState();
  const [_firstname, _setfirstname] = useState("");
  const [_firstnameEn, _setfirstnameEn] = useState("");
  const [_lastname, _setlastname] = useState("");
  const [_lastnameEn, _setlastnameEn] = useState("");
  const [_password, _setPassword] = useState("");
  const [_newpassword, _setNewPassword] = useState("");
  const [_username, _setUsername] = useState("");
  const [role, setRole] = useState({
    id: 2,
    role: "USER",
  });
  const [roleList, setRoleList] = useState([]);
  const [canAssignRole, setCanAssignRole] = useState(false);
  const [_mobile, _setMobile] = useState("");
  const [_openCheck, setOpenCheck] = useState(false);
  const { authToken } = useSelector((state) => state.auth);
  const [state, setState] = useState(false);

  useEffect(() => {
    getList();
    Promise.all([roleCheck('USER'), roleCheck('ROLE')]).then(([userTypes, roleTypes]) => {
      setCanAssignRole((hasAction(userTypes, 'CREATE') || hasAction(userTypes, 'EDIT')) && canAssignUserRole(userTypes, roleTypes));
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getList = async () => {
    //setPage(page);
    fetchAllListPages(`${baseURL}/api/v1/user/roles`, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${authToken}`,
      },
    }).then((res) => {
      if (res.message) {
        history.push("/logout");
      } else {
        console.log(res.data.data);
      }
      setRoleList(res.data.data);
    });
  };

  const handleSubmit = async (values, { setSubmitting }) => {
    if (!canAssignRole || !role) {
      setSubmitting(false);
      return Swal.fire('', 'ไม่มีสิทธิ์มอบ Role หรือยังไม่ได้เลือก Role', 'warning');
    }
    // await setSubmitting(true);
    let _get_shop_id = localStorage.getItem("shop_id");
    let _get_branch_id = localStorage.getItem("branch_id");

    var data = {
      firstname: values.firstname,
      lastname: values.lastname,
      email: values.email,
      password: values.password,
      role_id: role.id,
    };

    if (data.firstname && data.lastname && data.password) {
      let apiUrls = `${baseURL}/api/v1/user/create`;
      axios({
        method: "post",
        url: apiUrls,
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${authToken}`,
        },
        data: data,
      })
        .then((res) => {
          Swal.fire({
            title: intl.formatMessage({
              id: "113101",
              defaultMessage: "Save !",
            }),
            text: intl.formatMessage({
              id: "113106",
              defaultMessage: "Create user success",
            }),
            icon: "success",
            confirmButtonText: intl.formatMessage({
              id: "113116",
              defaultMessage: "ok",
            }),
          });
          history.goBack();
        })
        .catch((err) => {
          Swal.fire({
            title: intl.formatMessage({
              id: "113101",
              defaultMessage: "Save !",
            }),
            text: apiMessage(err, "สร้างผู้ใช้ไม่สำเร็จ กรุณาตรวจสอบข้อมูลแล้วลองใหม่"),
            icon: "error",
            confirmButtonText: intl.formatMessage({
              id: "113116",
              defaultMessage: "ok",
            }),
          });
        });
    } else {
      Swal.fire({
        title: intl.formatMessage({ id: "113101", defaultMessage: "Save !" }),
        text: intl.formatMessage({
          id: "113104",
          defaultMessage: "Your can not update user. !! ",
        }),
        icon: "error",
        confirmButtonText: intl.formatMessage({
          id: "113116",
          defaultMessage: "ok",
        }),
      });
    }
  };

  const _handleChangeSwitch = () => {
    setState(!state);
  };

  const _editUser = (values) => {};

  const _handleClose = () => {
    setOpenCheck(false);
  };
  return (
    <>
      <Card>
        <CardHeader
          title={intl.formatMessage({
            id: "109036",
            defaultMessage: "Create User management",
          })}
        ></CardHeader>
        <CardBody>
          <Formik
            initialValues={{
              email: "",
              firstname: "",
              lastname: "",
            }}
            validate={(values) => {
              let errors = {};
              if (!values.firstname)
                errors.firstname = intl.formatMessage({
                  id: "109012",
                  defaultMessage: "Firstname is required",
                });
              if (!values.lastname)
                errors.lastname = intl.formatMessage({
                  id: "109014",
                  defaultMessage: "lastname is required",
                });
              if (!values.email)
                errors.email = intl.formatMessage({
                  id: "109016",
                  defaultMessage: "email ",
                });
              if (
                !values.password ||
                values.password.length < 6 ||
                values.password.length > 12
              )
                errors.password = intl.formatMessage({
                  id: "113075",
                  defaultMessage:
                    "password is required at least 6 characters and most 12 characters",
                });
              //check if my values have errors
              return errors;
            }}
            onSubmit={handleSubmit}
            render={(formProps) => {
              return (
                <Form>
                  <div className="form-inline">
                    <p
                      style={{
                        marginTop: "15px",
                        float: "left",
                        width: "20%",
                      }}
                    >
                      {intl.formatMessage({
                        id: "109007",
                        defaultMessage: "firstname",
                      })}{" "}
                      :{" "}
                    </p>
                    <Field
                      type="text"
                      name="firstname"
                      className="form-control"
                      placeholder={intl.formatMessage({
                        id: "109007",
                        defaultMessage: "firstname",
                      })}
                      style={{
                        height: "38px",
                        width: "530px",
                        backgroundColor: "#F4F6F9",
                        borderRadius: "5px",
                        borderWidth: "0",
                      }}
                    />
                  </div>
                  <div className="form-inline">
                    <p
                      style={{
                        marginTop: "15px",
                        float: "left",
                        width: "20%",
                      }}
                    ></p>
                    <ErrorMessage className="colorError" name="firstname">
                      {(msg) => <div style={{ color: "red" }}>{msg}</div>}
                    </ErrorMessage>
                  </div>

                  <div className="form-inline">
                    <p
                      style={{
                        marginTop: "15px",
                        float: "left",
                        width: "20%",
                      }}
                    >
                      {intl.formatMessage({
                        id: "109009",
                        defaultMessage: "lastname",
                      })}{" "}
                      :{" "}
                    </p>
                    <Field
                      type="text"
                      name="lastname"
                      className="form-control"
                      placeholder={intl.formatMessage({
                        id: "109009",
                        defaultMessage: "lastname",
                      })}
                      style={{
                        height: "38px",
                        width: "530px",
                        backgroundColor: "#F4F6F9",
                        borderRadius: "5px",
                        borderWidth: "0",
                      }}
                    />
                  </div>
                  <div className="form-inline">
                    <p
                      style={{
                        marginTop: "15px",
                        float: "left",
                        width: "20%",
                      }}
                    ></p>
                    <ErrorMessage className="colorError" name="lastname">
                      {(msg) => <div style={{ color: "red" }}>{msg}</div>}
                    </ErrorMessage>
                  </div>

                  <div className="form-inline">
                    <p
                      style={{
                        marginTop: "15px",
                        float: "left",
                        width: "20%",
                      }}
                    >
                      {intl.formatMessage({
                        id: "113065",
                        defaultMessage: "email",
                      })}
                    </p>
                    <Field
                      type="text"
                      name="email"
                      className="form-control"
                      placeholder="email"
                      style={{
                        height: "38px",
                        width: "530px",
                        backgroundColor: "#F4F6F9",
                        borderRadius: "5px",
                        borderWidth: "0",
                      }}
                    />
                  </div>
                  <div className="form-inline">
                    <p
                      style={{
                        marginTop: "15px",
                        float: "left",
                        width: "20%",
                      }}
                    ></p>
                    <ErrorMessage className="colorError" name="email">
                      {(msg) => <div style={{ color: "red" }}>{msg}</div>}
                    </ErrorMessage>
                  </div>

                  <div className="form-inline">
                    <p
                      style={{
                        marginTop: "15px",
                        float: "left",
                        width: "20%",
                      }}
                    >
                      {intl.formatMessage({
                        id: "101006",
                        defaultMessage: "password",
                      })}{" "}
                      :{" "}
                    </p>

                    <Field
                      type="text"
                      name="password"
                      className="form-control"
                      maxLength={12}
                      placeholder={intl.formatMessage({
                        id: "101006",
                        defaultMessage: "Password",
                      })}
                      style={{
                        height: "38px",
                        width: "530px",
                        backgroundColor: "#F4F6F9",
                        borderRadius: "5px",
                        borderWidth: "0",
                      }}
                    />
                  </div>
                  <div className="form-inline">
                    <p
                      style={{
                        marginTop: "15px",
                        float: "left",
                        width: "20%",
                      }}
                    ></p>
                    <ErrorMessage className="colorError" name="password">
                      {(msg) => <div style={{ color: "red" }}>{msg}</div>}
                    </ErrorMessage>
                  </div>

                  <div className="form-inline">
                    <p
                      style={{
                        marginTop: "15px",
                        float: "left",
                        width: "20%",
                      }}
                    >
                      {intl.formatMessage({
                        id: "101006",
                        defaultMessage: "Role",
                      })}{" "}
                      :{" "}
                    </p>

                    <Autocomplete
                      //multiple
                      id="grouped-demo"
                      options={roleList}
                      //groupBy={(option) => option.topic_name}
                      getOptionLabel={(option) => option.role}
                      getOptionSelected={(option, value) =>
                        option.role === value.role
                      }
                      value={role}
                      onChange={(event, newValue) => {
                        setRole(newValue);
                      }}
                      style={{
                        width: "530px",
                        backgroundColor: "#F4F6F9",
                        borderRadius: "5px",
                        borderWidth: "0",
                      }}
                      renderInput={(params) => (
                        <TextField {...params} variant="outlined" />
                      )}
                    />
                  </div>

                  <CardHeaderToolbar>
                    <div
                      style={{
                        marginTop: "15px",
                        float: "left",
                        width: "20%",
                      }}
                    ></div>
                    <Link to="/User">
                      <button type="button" className="btn btn-secondary wbt">
                        {intl.formatMessage({
                          id: "109017",
                          defaultMessage: "cancel",
                        })}
                      </button>
                    </Link>
                    <button
                      className="btn btn-primary wbt"
                      type="submit"
                      disabled={!canAssignRole || formProps.isSubmitting}
                    >
                      {intl.formatMessage({
                        id: "109018",
                        defaultMessage: "save",
                      })}
                    </button>
                  </CardHeaderToolbar>
                </Form>
              );
            }}
          />
        </CardBody>
      </Card>
    </>
  );
};
